import React, { Component } from 'react';
import { formatNumber } from 'utils';
import cn from 'classnames';
import styles from './Area.scss';

import Button from '../../../../common/Button/Button';
import { withTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';

const digits = (number) => (number ? formatNumber(number) : '...');

const inputDigits = (number) => {
  const formattedNumber = formatNumber(parseInt(number, 10));
  return Number(number) === '0' || isNaN(parseInt(number, 10)) ? '' : formattedNumber;
};

export const parseSearch = (search) => {
  const { areaFrom, areaTo } = search;
  return { areaFrom, areaTo };
};

export const compileSearch = (data) => {
  const { areaFrom, areaTo } = data;
  const min = areaFrom ? Number(areaFrom) : undefined;
  const max = areaTo ? Number(areaTo) : undefined;
  return { areaFrom: min, areaTo: max };
};

export const compileRequest = compileSearch;

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { areaFrom, areaTo } = parseSearch(search);
  return areaFrom || areaTo
    ? `${digits(areaFrom)} - ${digits(areaTo)}`
    : i18n.t('components.header.filtersBar.filters.area.notSelected');
};

class Area extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...parseSearch(props.search)
    };

    this.handleMinValueChange = this.handleMinValueChange.bind(this);
    this.handleMaxValueChange = this.handleMaxValueChange.bind(this);
    this.handleClearButtonClick = this.handleClearButtonClick.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
  }

  updateSearch() {
    const { dropdownData } = this.props;
    const compiled = compileSearch(this.state);
    dropdownData(compiled, compiled);
  }

  parseValue(value) {
    const parsed = Number(parseInt(value.replace(/\s/g, ''), 10));
    return value ? (isNaN(parsed) ? undefined : parsed) : undefined;
  }

  handleMinValueChange(event) {
    const { value } = event.target;
    const areaFrom = this.parseValue(value);
    if (this.state.areaFrom !== areaFrom) {
      this.setState({ areaFrom }, this.updateSearch);
    }
  }

  handleMaxValueChange(event) {
    const { value } = event.target;
    const areaTo = this.parseValue(value);
    if (this.state.areaTo !== areaTo) {
      this.setState({ areaTo }, this.updateSearch);
    }
  }

  handleClearButtonClick() {
    this.setState({ areaFrom: undefined, areaTo: undefined }, this.updateSearch);
  }

  render() {
    const { className, chessfilter, t } = this.props;
    const { areaFrom, areaTo } = this.state;

    return (
      <div className={cn(styles.Menu, className, { [styles.MenuChessfilter]: chessfilter })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.area.title')}
          {
            !!(areaFrom || areaTo) &&
            <Button className={styles.Button} onClick={this.handleClearButtonClick}>
              {t('components.header.filtersBar.filters.area.clear')}
            </Button>
          }
        </p>
        <div className={styles.Inputs}>
          <input
            value={inputDigits(areaFrom)}
            onChange={this.handleMinValueChange}
            className={styles.Input}
            placeholder={chessfilter ? t('components.header.filtersBar.filters.area.from') : t('components.header.filtersBar.filters.area.fromFull')}
            maxLength="7"
          />
          <span className={styles.Dash}> – </span>
          <input
            value={inputDigits(areaTo)}
            onChange={this.handleMaxValueChange}
            className={styles.Input}
            placeholder={chessfilter ? t('components.header.filtersBar.filters.area.to') : t('components.header.filtersBar.filters.area.toFull')}
            maxLength="7"
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(Area);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Area/Area.js